<template>
  <div
    v-bind:style="{
      ...typography,
    }"
    v-bind:class="['demo__color--' + color]"
  >
    {{ $t(text) }}
  </div>
</template>

<script>
import Sizes from "./sizes";

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
      default: "black",
    },
  },
  data() {
    return {
      Sizes,
    };
  },
  computed: {
    typography() {
      const type = this.type ? this.type.split("/") : [];
      return this.Sizes[type[0]]?.[type[1]] || this.Sizes.default;
    },
  },
};
</script>
